import { z } from "zod";
export const npdProjectDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
});
